// @greenlight-spec: 16-api-conventions.md
// @greenlight-spec: 11-observability.md#cost-management
import { initContract } from '@ts-rest/core';
import { CostSummarySchema } from '@greenlight/shared';
import { errorResponses } from './common.js';
const c = initContract();
export const costContract = c.router({
    getSummary: {
        method: 'GET',
        path: '/api/cost',
        responses: {
            200: CostSummarySchema,
            ...errorResponses,
        },
        summary: "What Greenlight charges this org for the current UTC month, per app and for the install, priced at the install's own rate card (or list rates, with the reason); lifetime per app since measurement began; and build-session token cost at API-equivalent prices, never part of the totals. Not an invoice. org_admin only.",
    },
});
//# sourceMappingURL=cost.js.map